import { createFileRoute } from '@tanstack/react-router';

import { UserInfoStep } from '@/features/workspace/ui/user-info-step';
import { REDIRECT_PAGE } from '@/shared/redirect/constants';
import z from 'zod';

const searchParams = z.object({
  redirectPage: z.enum(REDIRECT_PAGE).optional(),
});

export const Route = createFileRoute('/workspace/create/user-info')({
  validateSearch: searchParams,
  component: UserInfoStep,
});
